import { PUBLIC_BASE_URL } from '@config/game.js'
import { createClient } from '@services'

const { get } = createClient()

/* API request to get current agreement */
export async function getCurrentAgreementRequest(agreementTemplateId) {
  const { data } = await get(
    `${PUBLIC_BASE_URL}/agreements/types/${agreementTemplateId}/current`
  )

  return data
}

/* API request to get agreement version */
export async function getAgreementVersionRequest(agreementVersionId) {
  const { data } = await get(
    `${PUBLIC_BASE_URL}/agreements/versions/${agreementVersionId}`
  )
  return data
}
